import ApiBase from '../api-base'
import { ACTIVE_BASE_REST } from '../constants'
export default class GeoControll extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/external/baraneh'
    super(store, path)
  }

  timeList(filter, showProgress) {
    return this._request({
      action: 'time/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  goodTypeList(filter, showProgress) {
    return this._request({
      action: 'good/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  packingList(filter, showProgress) {
    return this._request({
      action: 'packing/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  regionList(filter, showProgress) {
    return this._request({
      action: 'region/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  streetList(filter, showProgress) {
    return this._request({
      action: 'street/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  personalityList(filter, showProgress) {
    return this._request({
      action: 'personality/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  weightList(filter, showProgress) {
    return this._request({
      action: 'weight/list',
      method: 'GET',
      params: filter,
      showProgress
    })
  }
}
